import {STOCK_COMMAND_PKG} from './Stocks'
import {OPTIONS_COMMAND_PKG} from './Options'
import {CORONA_COMMAND_PKG} from "./Corona";
import {STOCK_CHART_COMMAND_PKG} from "./StockCharts";
import {CRYPTO_COMMAND_PKG} from "./Crypto";
import {EARNINGS_COMMAND_PKG} from "./Earnings";
import {FINVIZ_COMMAND_PKG} from "./FinViz";
import {FOREX_COMMAND_PGK} from "./Forex";
import {FUTURE_CHARTS_COMMAND_PKG} from "./FutureCharts";
import {FUTURES_COMMAND_PKG} from "./Futures";
import {MARKET_COMMAND_PKG} from "./General-Market-Info";
import {NON_US_COMMAND_PKG} from "./Non-US";
import {PRE_MARKET_COMMAND_PKG} from "./Premarket-Aftermarket-Commands";
import {SCAN_COMMAND_PKG} from "./Scans";
import {OTC_COMMAND_PKG} from "./OTC-Commands-Charting";
import {DARKPOOL_PKG} from "./Darkpool";


const ALL_COMMANDS = [
    STOCK_COMMAND_PKG,
    OPTIONS_COMMAND_PKG,
    DARKPOOL_PKG,
    CORONA_COMMAND_PKG,
    STOCK_CHART_COMMAND_PKG,
    CRYPTO_COMMAND_PKG,
    EARNINGS_COMMAND_PKG,
    FINVIZ_COMMAND_PKG,
    FOREX_COMMAND_PGK,
    FUTURE_CHARTS_COMMAND_PKG,
    FUTURES_COMMAND_PKG,
    MARKET_COMMAND_PKG,
    NON_US_COMMAND_PKG,
    PRE_MARKET_COMMAND_PKG,
    SCAN_COMMAND_PKG,
    OTC_COMMAND_PKG,
]

// Creates an array with every single individual command
function createUltimateArray() {

    let ultimateArray = []
    for (let commandPackage of ALL_COMMANDS){
        ultimateArray.push(...commandPackage.commandList)
    }

    return ultimateArray
}

const ULTIMATE_ARRAY = createUltimateArray()

export {ALL_COMMANDS, ULTIMATE_ARRAY};

